// Cuisine picker: preset list plus "Other" with a free-text box. The value saved is
// always the plain cuisine text (a preset or whatever the user typed).
import { useState } from 'react';

export const CUISINES = [
  'Modern Australian', 'Cafe', 'Italian', 'Mediterranean', 'Middle Eastern', 'Turkish', 'Greek', 'French',
  'Japanese', 'Chinese', 'Thai', 'Vietnamese', 'Korean', 'Indian', 'Asian Fusion', 'Mexican',
  'Seafood', 'Steakhouse', 'Bakery', 'Fine Dining', 'Bar', 'Pub',
];
const OTHER = '__other__';

export default function CuisineField({ value, onChange, selectClassName, inputClassName, style }: {
  value: string;
  onChange: (v: string) => void;
  selectClassName: string;
  inputClassName?: string;
  style?: React.CSSProperties;
}) {
  // A saved value that isn't a preset (e.g. "Lebanese") opens straight into the text box.
  const [custom, setCustom] = useState(() => !!value && !CUISINES.includes(value));
  return (
    <div className="space-y-2">
      <select
        value={custom ? OTHER : value}
        onChange={(e) => {
          if (e.target.value === OTHER) { setCustom(true); onChange(''); }
          else { setCustom(false); onChange(e.target.value); }
        }}
        className={selectClassName}
        style={style}
      >
        <option value="">Select one</option>
        {CUISINES.map((cz) => <option key={cz} value={cz}>{cz}</option>)}
        <option value={OTHER}>Other (type your own)</option>
      </select>
      {custom && (
        <input
          autoFocus
          value={value}
          onChange={(e) => onChange(e.target.value)}
          maxLength={60}
          placeholder="e.g. Lebanese, Brunch & specialty coffee"
          className={inputClassName ?? selectClassName}
          style={style}
        />
      )}
    </div>
  );
}
